import { useQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';

import { tournamentIdAtom } from 'atoms/tournament';
import { type InitialDrawDisplaySettings } from 'components/dialogs/draw/publicDrawDisplaySettings/types';
import { GET_DRAW_SETTINGS } from 'config/graphql/queries';
import { isStandalone } from 'utils/environment';

const useDrawSettings = () => {
  const tournamentId = useAtomValue(tournamentIdAtom);
  const res = useQuery<InitialDrawDisplaySettings>(GET_DRAW_SETTINGS, {
    fetchPolicy: isStandalone() ? 'cache-only' : 'cache-first',
    variables: { tournamentId },
  });
  return res?.data?.settings || {};
};

export default useDrawSettings;
